export default "__VITE_ASSET__CEtxc46t__"